// import React, { useState } from 'react';
// import Papa from 'papaparse';
// import * as XLSX from 'xlsx';

// const Home = () => {

//     const [foFileData, setFoFileData] = useState([]);
//     const [mcxFileData, setMcxFileData] = useState([]);
//     const [cmFileData, setCmFileData] = useState([]);


//     const handlefoFiles = (e) => {
//         const file = e.target.files[0]

//         if (file) {
//             Papa.parse(file, {
//                 header: true,
//                 complete: function (results) {
//                     console.log(results);
//                     const data = results.data;
//                     const fo = data.map((row) => row['Cash allocated (b)']); // Replace 'YourColumnName' with the actual column header

//                     setFoFileData(fo);

//                 }
//             })
//         }
//     }


//     const handlecmFiles = (e) => {
//         const file = e.target.files[0]

//         if (file) {
//             Papa.parse(file, {
//                 header: true,
//                 complete: function (results) {
//                     console.log(results);
//                     const data = results.data;
//                     const cm = data.map((row) => row['Cash allocated (b)']);

//                     setCmFileData(cm);

//                 }
//             })
//         }
//     }


//     const handlemcxFiles = (e) => {
//         const file = e.target.files[0]

//         if (file) {
//             Papa.parse(file, {
//                 header: true,
//                 complete: function (results) {
//                     console.log(results);
//                     const data = results.data;

//                     console.log("hello", data)
//                     const mcx = data.map((row) => row['Branch']); // Replace 'YourColumnName' with the actual column header

//                     setMcxFileData(mcx);


//                 }
//             })
//         }
//     }

//     const handleFileChange = (e) => {
//         const file = e.target.files[0];
//         if (file && file.name.endsWith('.xlsx')) {
//             const reader = new FileReader();
//             reader.onload = (event) => {
//                 const binaryStr = event.target.result;
//                 const workbook = XLSX.read(binaryStr, { type: 'binary' });
//                 const firstSheetName = workbook.SheetNames[0];
//                 const worksheet = workbook.Sheets[firstSheetName];
//                 const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 }); // Get data as an array of arrays
//                 const allocationColumnData = data.map((row) => row[9]); // Assuming "Allocation at EOD" is in the 9th column
//                 console.log('Allocation at EOD Data:', allocationColumnData);
//             };
//             reader.readAsBinaryString(file);
//         }
//     };



//     console.log("f&o", foFileData)
//     console.log("mcx", mcxFileData)
//     console.log("cm", cmFileData)


//     return (
//         <>



//             <div className='row'>
//                 <div className='col-md-3'>
//                     <input type='file' className='my-3' accept='.csv,.xlsx' onChange={handlefoFiles} />

//                     <input type='file' className='my-3'  accept='.csv,.xlsx' onChange={handlecmFiles} />

//                     <input type='file' className='my-3' accept='.csv,.xlsx' onChange={handleFileChange} />

//                 </div>


//             </div>


//         </>
//     )
// }

// export default Home


import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import Papa from 'papaparse';
import { useNavigate } from 'react-router-dom';
import { notyf } from '../Inits';

const Home = () => {


    const [drFile, setDrFile] = useState(null);
    const [foFile, setFoFile] = useState(null);
    const [cmFile, setCmFile] = useState(null);
    const [mcxFile, setMcxFile] = useState(null);
    const navigate = useNavigate();

    const handleFileChange = (e, setFile) => {
        setFile(e.target.files[0]);
    };


    const processFiles = () => {
        if (!drFile || !foFile || !cmFile || !mcxFile) {
            notyf.error('Please upload All files')
            return;
        }

        Promise.all([
            processDrFile(drFile),
            processFoFile(foFile),
            processCmFile(cmFile),
            processMcxFile(mcxFile),
        ]).then(([drData, foData, cmData, mcxData]) => {
            // const finalResults = drData.map(({ accountId, nonMcrValue }) => {
            //     const cashAllocated =
            //         (foData[accountId] || 0) + (cmData[accountId] || 0) + (mcxData[accountId] || 0);
            //     // const result = (nonMcrValue - cashAllocated).toFixed(2);
            //     const result = parseFloat((nonMcrValue - cashAllocated).toFixed(2))
            //     return { accountId, result, cashAllocated };
            // });

            // console.log('Final results:', finalResults);
            // setTableData(finalResults); 

            const finalResults = drData.map(({ accountId, nonMcrValue, netCredit }) => {
                const foValue = foData[accountId] || 0;
                const cmValue = cmData[accountId] || 0;
                const mcxValue = mcxData[accountId] || 0;

                const cashAllocated = foValue + cmValue + mcxValue;
                const result = parseFloat((nonMcrValue - cashAllocated).toFixed(2))
                const cheq = parseFloat((netCredit - cashAllocated).toFixed(2))

                if (result !== 0 && cheq !== 0) {
                    return {
                        accountId,
                        result,
                        cashAllocated,
                        foValue,
                        cmValue,
                        mcxValue,
                        nonMcrValue,
                        netCredit,
                        cheq,
                    }
                }
                // Return null if either result or cheq is zero
                return null;
            })
                .filter(item => item !== null); // Filter out any null values


            // return { accountId, result, cashAllocated, foValue, cmValue, mcxValue, nonMcrValue, netCredit, cheq };

            console.log('Final results:', finalResults);
            navigate('/results', { state: { tableData: finalResults } });

            // Create a worksheet from the finalResults array
            const worksheet = XLSX.utils.json_to_sheet(finalResults);

            // Create a new workbook and append the worksheet
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Results');

            // Generate a file and trigger a download
            XLSX.writeFile(workbook, 'ProcessedResults.xlsx');

        });

    }

    // Processing DR CR File
    const processDrFile = (file) => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                const binaryStr = event.target.result;
                const workbook = XLSX.read(binaryStr, { type: 'binary' });
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];
                const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                // Find the index of the 'Account ID' and 'non-mcr' columns in the header row
                const headerRow = data[0];
                const accountIdIndex = headerRow.indexOf('Account ID');
                const nonMcrIndex = headerRow.indexOf('Non MTF Cr.');

                const netCredit = headerRow.indexOf('Net Credit');

                const resultData = data.slice(1).map((row) => ({
                    accountId: row[accountIdIndex],
                    nonMcrValue: parseFloat(row[nonMcrIndex]) || 0,
                    netCredit: parseFloat(row[netCredit]) || 0
                }));

                resolve(resultData);
            };
            reader.readAsBinaryString(file);
        });
    };

    // Processing FO File
    const processFoFile = (file) => {
        return new Promise((resolve) => {
            Papa.parse(file, {
                complete: (results) => {
                    const data = results.data;
                    // Find the index of the 'Account ID' and 'cashallocated' columns in the header row
                    const headerRow = data[0];
                    const accountIdIndex = headerRow.indexOf('Client Code');
                    const cashAllocatedIndex = headerRow.indexOf('Cash allocated (b)');

                    const resultData = data.slice(1).reduce((acc, row) => {
                        const accountId = row[accountIdIndex];
                        const cashAllocated = parseFloat(row[cashAllocatedIndex]) || 0;
                        acc[accountId] = cashAllocated;
                        return acc;
                    }, {});

                    resolve(resultData);
                },
                header: false,
            });
        });
    };

    //Processing CM File
    const processCmFile = (file) => {
        return new Promise((resolve) => {
            Papa.parse(file, {
                complete: (results) => {
                    const data = results.data;
                    // Find the index of the 'Account ID' and 'cashallocated' columns in the header row
                    const headerRow = data[0];
                    const accountIdIndex = headerRow.indexOf('Client Code');
                    const cashAllocatedIndex = headerRow.indexOf('Cash allocated (b)');

                    const resultData = data.slice(1).reduce((acc, row) => {
                        const accountId = row[accountIdIndex];
                        const cashAllocated = parseFloat(row[cashAllocatedIndex]) || 0;
                        acc[accountId] = cashAllocated;
                        return acc;
                    }, {});

                    resolve(resultData);
                },
                header: false,
            });
        });
    };

    // Function to process the MCX Excel file and get the cashallocated value for each Account ID
    // const processMcxFile = (file) => {
    //     return new Promise((resolve) => {
    //         const reader = new FileReader();
    //         reader.onload = (event) => {
    //             const binaryStr = event.target.result;
    //             const workbook = XLSX.read(binaryStr, { type: 'binary' });
    //             const firstSheetName = workbook.SheetNames[0];
    //             const worksheet = workbook.Sheets[firstSheetName];
    //             const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

    //             // Find the index of the 'Account ID' and 'cashallocated' columns in the header row
    //             const headerRow = data[0];
    //             const accountIdIndex = headerRow.indexOf('UCC Code');
    //             const cashAllocatedIndex = headerRow.indexOf('Allocation at EOD');

    //             const resultData = data.slice(1).reduce((acc, row) => {
    //                 const accountId = row[accountIdIndex];
    //                 const cashAllocated = parseFloat(row[cashAllocatedIndex]) || 0;
    //                 acc[accountId] = cashAllocated;
    //                 return acc;
    //             }, {});

    //             resolve(resultData);
    //         };
    //         reader.readAsBinaryString(file);
    //     });
    // };



    const processMcxFile = (file) => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                const binaryStr = event.target.result;
                const workbook = XLSX.read(binaryStr, { type: 'binary' });
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];
                const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                // Log the header row to verify the column names
                console.log('MCX Header Row:', data[0]);

                // Find the index of the 'UCC Code' and 'Allocation at EOD' columns in the header row
                const headerRow = data[2];
                const accountIdIndex = headerRow.indexOf('UCC Code');
                const cashAllocatedIndex = headerRow.indexOf('Allocation at EOD');

                if (accountIdIndex === -1 || cashAllocatedIndex === -1) {
                    console.error('Error: Column names "UCC Code" or "Allocation at EOD" not found in the MCX file.');
                    resolve({});
                    return;
                }

                const resultData = data.slice(3).reduce((acc, row) => {
                    const accountId = row[accountIdIndex];
                    // Remove commas from the value and then parse it as a float
                    const cashAllocated = parseFloat(row[cashAllocatedIndex]?.toString().replace(/,/g, '')) || 0;
                    acc[accountId] = cashAllocated;
                    return acc;
                }, {});

                // const resultData = data.slice(1).reduce((acc, row) => {
                //     const accountId = row[accountIdIndex];
                //     const cashAllocated = parseFloat(row[cashAllocatedIndex]) || 0;
                //     acc[accountId] = cashAllocated;
                //     return acc;
                // }, {});

                resolve(resultData);
            };
            reader.readAsBinaryString(file);
        });
    };

    // const headerStyle = {
    //     backgroundColor: '#f2f2f2',
    //     // padding: '8px',
    //     textAlign: 'left',
    //     fontWeight: 'bold',
    //     borderBottom: '2px solid #ddd',
    // };

    // const cellStyle = {
    //     padding: '8px',
    //     border: '1px solid #ddd',
    //     textAlign: 'right',
    //     backgroundColor: '#fff',
    // };


    return (

        <div className='row m-0'>
            <div className='col-md-12 d-flex justify-content-center my-5'>
                <div className='card calc-card col-md-6 d-flex align-items-center'>
                    <div className='text-center my-4'>
                        <img className="logo-icon" alt="logo" src='/Images/logo.png' />
                    </div>

                    <div className="col-md-7 form-row mb-3">
                        <label className="form-label fw-bold">Upload Dr File </label>
                        <div className={"form-holder"}>
                            <input type="file" className={"form-control "} placeholder="Select File" accept=".xlsx" onChange={(e) => handleFileChange(e, setDrFile)} />
                        </div>
                    </div>

                    <div className="col-md-7 form-row mb-3">
                        <label className="form-label fw-bold">Upload F&O File </label>
                        <div className={"form-holder"}>
                            <input type="file" className={"form-control "} placeholder="Select File" accept=".csv" onChange={(e) => handleFileChange(e, setFoFile)} />
                        </div>
                    </div>

                    <div className="col-md-7 form-row mb-3">
                        <label className="form-label fw-bold">Upload CM File </label>
                        <div className={"form-holder"}>
                            <input type="file" className={"form-control "} placeholder="Select File" accept=".csv" onChange={(e) => handleFileChange(e, setCmFile)} />
                        </div>
                    </div>

                    <div className="col-md-7 form-row mb-3">
                        <label className="form-label fw-bold">Upload MCX File </label>
                        <div className={"form-holder"}>
                            <input type="file" className={"form-control "} placeholder="Select File" accept=".xlsx" onChange={(e) => handleFileChange(e, setMcxFile)} />
                        </div>
                    </div>
                    <div className='text-center mt-4'>
                        <button className='btn btn-sm process-btn px-3 py-2' onClick={processFiles}>Process Files</button>

                    </div>


                </div>

            </div>
            {/* <div className='col-md-9'>
                {renderExcelLikeTable()}

                {tableData.length > 0 && (
                    <div style={{ overflowX: 'auto', overflowY: 'auto', maxWidth: '100%', marginTop: '20px' }}>
                        <table
                            style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                            }}
                        >
                            <thead>
                                <tr>
                                    <th style={headerStyle}>Account ID</th>
                                    <th style={headerStyle}>FNO</th>
                                    <th style={headerStyle}>CM</th>
                                    <th style={headerStyle}>MCX</th>
                                    <th style={headerStyle}>Non MTF Cr</th>
                                    <th style={headerStyle}>Tot CashAllocated</th>
                                    <th style={headerStyle}>Difference</th>

                                </tr>
                            </thead>
                            <tbody>
                                {tableData.map((row, index) => (
                                    <tr key={index}>
                                        <td style={cellStyle}>{row.accountId}</td>
                                        <td style={cellStyle}>{row.foValue}</td>
                                        <td style={cellStyle}>{row.cmValue}</td>
                                        <td style={cellStyle}>{row.mcxValue}</td>
                                        <td style={cellStyle}>{row.nonMcrValue}</td>
                                        <td style={cellStyle}>{row.cashAllocated}</td>
                                        <td style={cellStyle}>{row.result}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div> */}

            {/* <div className='col-md-12'>

                <div className='col-md-6 card file-card mx-auto'>
                    <div className='py-4 text-center'>
                        <img className="logo-icon" alt="logo" src='/Images/logo.png' />
                    </div>
                    <div className="form-row mb-3">
                        <label className="form-label fw-bold">Upload Dr File </label>
                        <div className={"form-holder"}>
                            <input type="file" className={"form-control "} placeholder="Select File" accept=".xlsx" onChange={(e) => handleFileChange(e, setDrFile)} />
                        </div>
                    </div>

                    <div className="form-row mb-3">
                        <label className="form-label fw-bold">Upload F&O File </label>
                        <div className={"form-holder"}>
                            <input type="file" className={"form-control "} placeholder="Select File" accept=".csv" onChange={(e) => handleFileChange(e, setFoFile)} />
                        </div>
                    </div>

                    <div className="form-row mb-3">
                        <label className="form-label fw-bold">Upload CM File </label>
                        <div className={"form-holder"}>
                            <input type="file" className={"form-control "} placeholder="Select File" accept=".csv" onChange={(e) => handleFileChange(e, setCmFile)} />
                        </div>
                    </div>

                    <div className="form-row mb-3">
                        <label className="form-label fw-bold">Upload MCX File </label>
                        <div className={"form-holder"}>
                            <input type="file" className={"form-control "} placeholder="Select File" accept=".xlsx" onChange={(e) => handleFileChange(e, setMcxFile)} />
                        </div>
                    </div>
                    <div className='text-center mt-4'>
                        <button className='btn btn-sm process-btn px-3 py-2' onClick={processFiles}>Process Files</button>
                    </div>
                </div>
            </div> */}

        </div>
    )
}

export default Home